import CheckboxFilter, {
  CheckboxFilterItem,
} from "@/components/checkbox-filter";
import EmptyState from "@/components/empty-state";
import InputSearch from "@/components/input-search";
import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/ui/data-table";
import { pageSize } from "@/config/pagination.config";
import { useListResources } from "@/hooks/list-resources.hook";
import { useResourceLibrary } from "@/hooks/resource-library.hook";
import {
  ListResourcesResponseContent,
  ListResourcesResponseContentType,
} from "@/requests/libraries/list-resources.request";
import { Row } from "@tanstack/react-table";
import { Book1 } from "iconsax-react";
import { useState } from "react";
import { useDebounce } from "use-debounce";
import PreviewResourceDrawer from "../../../components/library-drawers/preview-resource-drawer";
import { columns } from "./columns";
import {
  useResourceListActions,
  useResourceListIsPreviewDrawerOpen,
  useResourceListResource,
} from "./resource-list.store";

const initialSourceFilter: CheckboxFilterItem[] = [
  {
    id: "LINK",
    value: "Público",
    checked: false,
  },
  {
    id: "FILE",
    value: "Interno",
    checked: false,
  },
];

// const items: CheckboxFilterItem[] = [
//   { name: "Matriz de riesgos", checked: false },
//   { name: "Mecanismos y procesos formales", checked: false },
//   { name: "Política", checked: false },
//   { name: "Proceso de auditoría", checked: false },
//   { name: "Programa de formación", checked: false },
//   { name: "Programa, proyecto o iniciativa", checked: false },
//   { name: "Declaración jurada", checked: false },
//   { name: "Programas empresariales", checked: false },
//   { name: "Indicadores empresariales", checked: false },
//   { name: "Programa", checked: false },
//   { name: "Indicador", checked: false },
// ];

const ResourcesList = () => {
  const [sourceItems, setSourceItems] =
    useState<CheckboxFilterItem[]>(initialSourceFilter);

  const isPreviewDrawerOpen = useResourceListIsPreviewDrawerOpen();

  const resource = useResourceListResource();

  const { setIsPreviewDrawerOpen, setResource } = useResourceListActions();

  const [q, setQ] = useState("");

  const [pagination, setPagination] = useState({
    pageIndex: 0, // current page index
    pageSize: pageSize,
  });

  const [debouncedQ] = useDebounce(q, 500);

  const typesFilter = sourceItems
    .filter((item) => item.checked)
    .map((item) => item.id) as ListResourcesResponseContentType[];

  const hasFilterApplied =
    debouncedQ.trim().length > 0 || typesFilter.length > 0;

  const { data: resourceLibrary } = useResourceLibrary();

  const { data: resourcesList, isLoading: isResourcesListLoading } =
    useListResources({
      companyId: resourceLibrary?.owner.id || "",
      resourceLibraryId: resourceLibrary?.id || "",
      q: debouncedQ,
      types: typesFilter,
      size: pagination.pageSize,
      page: pagination.pageIndex,
    });

  const handlePreviewOpenChange = (isOpen: boolean) => {
    setIsPreviewDrawerOpen(isOpen);

    if (!isOpen) {
      setResource(null);
    }
  };

  const handleRowClick = (row: Row<ListResourcesResponseContent>) => {
    setResource(row.original);
    setIsPreviewDrawerOpen(true);
  };

  const handleResetFilters = () => {
    setQ("");
    setSourceItems(initialSourceFilter);
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <InputSearch
          value={q}
          placeholder="Buscar por nombre"
          onChange={setQ}
          className="max-w-sm grow"
        />

        <CheckboxFilter
          label="Fuente"
          items={sourceItems}
          onCheckedChange={(_, items) => {
            setSourceItems(items);
          }}
        />

        {/* <CheckboxFilter placeholder="Tipo de cumplimiento" /> */}
      </div>

      <DataTable
        className="mt-4 flex grow flex-col"
        columns={columns}
        data={resourcesList?.content || []}
        onRowClick={handleRowClick}
        manualPagination={true}
        rowCount={resourcesList?.totalElements || 0}
        onPaginationChange={setPagination}
        pagination={pagination}
        emptyState={
          <EmptyState
            icon={Book1}
            className="mx-auto my-8"
            message={
              hasFilterApplied
                ? "No encontramos ningún recurso que coincida con tus criterios de búsqueda. Prueba ajustando los filtros para ver más resultados."
                : "No has publicado ningún recurso aún."
            }
          >
            {hasFilterApplied && (
              <Button
                className="mt-4"
                variant={"outline"}
                onClick={handleResetFilters}
              >
                Quitar filtros
              </Button>
            )}
          </EmptyState>
        }
        isLoading={isResourcesListLoading}
      />

      {resource && (
        <PreviewResourceDrawer
          isOpen={isPreviewDrawerOpen}
          onOpenChange={handlePreviewOpenChange}
          resourceId={resource.id}
        />
      )}
    </>
  );
};

export default ResourcesList;
